var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.43425C16 5.53882 13.3137 6.43425 10 6.43425C6.68629 6.43425 4 5.53882 4 4.43425M16 4.43425C16 3.32968 13.3137 2.43425 10 2.43425C6.68629 2.43425 4 3.32968 4 4.43425M16 4.43425V8.43425M4 4.43425V8.43425C4 9.53882 6.68629 10.4342 10 10.4342C13.3137 10.4342 16 9.53882 16 8.43425M20 10.3204C20 11.425 17.3137 12.3204 14 12.3204C10.6863 12.3204 8 11.425 8 10.3204V14.3205M20 10.3204C20 9.44963 18.3304 8.70881 16 8.43425M20 10.3204V14.3205C20 15.425 17.3137 16.3205 14 16.3205C10.6863 16.3205 8 15.425 8 14.3205M4 16.2067C4 17.3112 6.68629 18.2067 10 18.2067C13.3137 18.2067 16 17.3112 16 16.2067V20.2067C16 21.3113 13.3137 22.2067 10 22.2067C6.68629 22.2067 4 21.3113 4 20.2067V16.2067ZM4 16.2067C4 15.3359 5.66962 14.595 8 14.3205",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.2e121178187082e04bf57b53cd2b8487.svg";
export { ForwardRef as ReactComponent };